export default {
  $header: $('.banner'),
  window: $(window),
  navCollapseFrom: 80,
  navIsCollapsed: false,
  // $isMobile: false,

  init() {
    // this.measureWindowWidth();
    // this.window.on('resize', () => this.measureWindowWidth());

    // if (!this.$isMobile) {
      this.window.on('scroll', () => this.onWindowScroll());
      this.onWindowScroll();
    // }

    this.initWallpaperSelector();
  },
  // measureWindowWidth() {
  //   if (window.innerWidth < 992) {
  //     this.$isMobile = true;
  //   } else {
  //     this.$isMobile = false;
  //   }
  // },
  onWindowScroll() {
    if (this.window.scrollTop() > this.navCollapseFrom) {
      if (!this.navIsCollapsed) {
        this.$header.addClass('is-sticky');
        this.navIsCollapsed = true;
      }
    } else {
      if (this.navIsCollapsed) {
        this.$header.removeClass('is-sticky');
        this.navIsCollapsed = false;
      }
    }
  },
  initWallpaperSelector() {
    // Check if wallpaper selector exists on page
    if (!$('#wallpaper-selector').length) {
      return;
    }

    const $selector = $('#wallpaper-selector');
    const $tabs = $selector.find('.wallpaper-tab-button');
    const $panels = $selector.find('.wallpaper-panel');
    const $selected = $('#wallpaper-selected');
    const $lightbox = $('#wallpaper-lightbox');
    const $lightboxImage = $('#wallpaper-lightbox-img');
    const $lightboxSelect = $('#wallpaper-lightbox-select');

    const updateLightboxNavButtons = (totalImages, currentIndex) => {
      const $prev = $lightbox.find('.wallpaper-lightbox-prev');
      const $next = $lightbox.find('.wallpaper-lightbox-next');

      if (currentIndex <= 0) {
        $prev.hide();
      } else {
        $prev.show();
      }

      if (currentIndex >= totalImages - 1) {
        $next.hide();
      } else {
        $next.show();
      }
    };

    const navigateLightbox = (direction) => {
      const currentIndex = $lightboxImage.data('current-index');
      const categoryId = $lightboxImage.data('category-id');
      const $panel = $('#wallpaper-panel-' + categoryId);
      const images = $panel.find('.wallpaper-image-item');

      const newIndex = currentIndex + direction;
      if (newIndex < 0 || newIndex >= images.length) {
        return;
      }

      const $newItem = images.eq(newIndex);
      const newUrl = $newItem.find('img').data('full') || $newItem.find('img').attr('src');
      const newImageId = $newItem.find('.wallpaper-select-btn').data('image-id');
      const categoryName = $panel.data('category-name');
      const newTitle = $newItem.find('img').data('title') || $newItem.find('img').attr('alt') || '';

      $lightboxImage
        .attr('src', newUrl)
        .data('current-index', newIndex)
        .data('image-id', newImageId)
        .data('image-url', newUrl)
        .data('category-name', categoryName)
        .data('image-title', newTitle);

      updateLightboxNavButtons(images.length, newIndex);
    };

    // Ensure hidden inputs are inside the add to cart form on page load
    const $form = $('form.cart, form.variations_form').first();
    if ($form.length) {
      $('#selected_wallpaper_image_id, #selected_wallpaper_image_url, #selected_wallpaper_category, #selected_wallpaper_title').each(function() {
        const $input = $(this);
        if ($input.length && $input.closest('form').length === 0) {
          $form.append($input);
        }
      });
    }

    // Tab switching
    $tabs.on('click', function(e) {
      e.preventDefault();
      const $tab = $(this);
      const categoryId = $tab.data('category-id');
      const $panel = $selector.find(`#wallpaper-panel-${categoryId}`);

      // Update active states
      $tabs.removeClass('active').attr('aria-selected', 'false');
      $tab.addClass('active').attr('aria-selected', 'true');
      $panels.removeClass('active');
      $panel.addClass('active');
    });


    // Image selection
    $selector.on('click', '.wallpaper-select-btn', function(e) {
      e.preventDefault();
      const $btn = $(this);
      const $item = $btn.closest('.wallpaper-image-item');
      const imageId = $btn.data('image-id');
      const $img = $item.find('img');
      const imageUrl = $img.data('full') || $img.attr('src');
      const imageTitle = $img.data('title') || $img.attr('alt') || '';
      const $panel = $item.closest('.wallpaper-panel');
      const categoryId = $panel.data('category-id');
      const categoryName = $panel.data('category-name');

      // Update selected state
      $selector.find('.wallpaper-image-item').removeClass('selected');
      $item.addClass('selected');

      // Update hidden inputs
      $('#selected_wallpaper_image_id').val(imageId);
      $('#selected_wallpaper_image_url').val(imageUrl);
      $('#selected_wallpaper_category').val(categoryName);
      $('#selected_wallpaper_title').val(imageTitle);

      // Ensure hidden inputs are inside the add to cart form
      const $form = $('form.cart, form.variations_form').first();
      if ($form.length) {
        // Move or create inputs inside the form
        let $inputId = $('#selected_wallpaper_image_id');
        let $inputUrl = $('#selected_wallpaper_image_url');
        let $inputCat = $('#selected_wallpaper_category');
        let $inputTitle = $('#selected_wallpaper_title');

        if ($inputId.length && $inputId.closest('form').length === 0) {
          $form.append($inputId);
        } else if (!$inputId.length) {
          $form.append('<input type="hidden" name="selected_wallpaper_image_id" id="selected_wallpaper_image_id" value="' + imageId + '">');
        }

        if ($inputUrl.length && $inputUrl.closest('form').length === 0) {
          $form.append($inputUrl);
        } else if (!$inputUrl.length) {
          $form.append('<input type="hidden" name="selected_wallpaper_image_url" id="selected_wallpaper_image_url" value="' + imageUrl + '">');
        }

        if ($inputCat.length && $inputCat.closest('form').length === 0) {
          $form.append($inputCat);
        } else if (!$inputCat.length) {
          $form.append('<input type="hidden" name="selected_wallpaper_category" id="selected_wallpaper_category" value="' + categoryName + '">');
        }

        if ($inputTitle.length && $inputTitle.closest('form').length === 0) {
          $form.append($inputTitle);
        } else if (!$inputTitle.length) {
          $form.append('<input type="hidden" name="selected_wallpaper_title" id="selected_wallpaper_title" value="' + imageTitle + '">');
        }
      }

      showSelectedImage(imageUrl, categoryName, imageTitle);
    });

    // Preview when clicking anywhere on the image wrapper (except the select button)
    $selector.on('click', '.wallpaper-image-wrapper', function(e) {
      if ($(e.target).closest('.wallpaper-select-btn').length) {
        // Let the select button handler process this click
        return;
      }

      e.preventDefault();
      const $img = $(this).find('img');
      const imageUrl = $img.data('full') || $img.attr('src');
      const $item = $(this).closest('.wallpaper-image-item');
      const $panel = $item.closest('.wallpaper-panel');
      const categoryId = $panel.data('category-id');
      const categoryName = $panel.data('category-name');
      const images = $panel.find('.wallpaper-image-item');
      const currentIndex = images.index($item);
      const imageId = $item.find('.wallpaper-select-btn').data('image-id');
      const imageTitle = $img.data('title') || $img.attr('alt') || '';

      $lightboxImage
        .attr('src', imageUrl)
        .data('current-index', currentIndex)
        .data('category-id', categoryId)
        .data('image-id', imageId)
        .data('image-url', imageUrl)
        .data('category-name', categoryName)
        .data('image-title', imageTitle);

      updateLightboxNavButtons(images.length, currentIndex);

      $lightbox.fadeIn(300);
      $('body').addClass('wallpaper-lightbox-open');
    });

    // Lightbox select button
    $lightboxSelect.on('click', function(e) {
      e.preventDefault();
      const imageId = $lightboxImage.data('image-id');
      const imageUrl = $lightboxImage.data('image-url');
      const categoryName = $lightboxImage.data('category-name');
      const imageTitle = $lightboxImage.data('image-title') || '';

      if (!imageId || !imageUrl || !categoryName) {
        return;
      }

      $('#selected_wallpaper_image_id').val(imageId);
      $('#selected_wallpaper_image_url').val(imageUrl);
      $('#selected_wallpaper_category').val(categoryName);
      $('#selected_wallpaper_title').val(imageTitle);

      showSelectedImage(imageUrl, categoryName, imageTitle);

      $lightbox.fadeOut(300);
      $('body').removeClass('wallpaper-lightbox-open');
    });

    // Close lightbox
    $lightbox.on('click', '.wallpaper-lightbox-overlay, .wallpaper-lightbox-close', function(e) {
      e.preventDefault();
      $lightbox.fadeOut(300);
      $('body').removeClass('wallpaper-lightbox-open');
    });

    // Close lightbox on ESC key
    $(document).on('keydown', function(e) {
      if (e.key === 'Escape' && $lightbox.is(':visible')) {
        $lightbox.fadeOut(300);
        $('body').removeClass('wallpaper-lightbox-open');
      } else if (e.key === 'ArrowRight' && $lightbox.is(':visible')) {
        $lightbox.find('.wallpaper-lightbox-next:visible').trigger('click');
      } else if (e.key === 'ArrowLeft' && $lightbox.is(':visible')) {
        $lightbox.find('.wallpaper-lightbox-prev:visible').trigger('click');
      }
    });

    // Lightbox navigation
    $lightbox.on('click', '.wallpaper-lightbox-nav', function(e) {
      e.preventDefault();
      const direction = $(this).hasClass('wallpaper-lightbox-next') ? 1 : -1;
      navigateLightbox(direction);
    });

    // Lightbox select button
    $lightboxSelect.on('click', function(e) {
      e.preventDefault();
      const imageId = $lightboxImage.data('image-id');
      const imageUrl = $lightboxImage.data('image-url');
      const categoryName = $lightboxImage.data('category-name');
      const imageTitle = $lightboxImage.data('image-title') || '';

      if (!imageId || !imageUrl || !categoryName) {
        return;
      }

      $('#selected_wallpaper_image_id').val(imageId);
      $('#selected_wallpaper_image_url').val(imageUrl);
      $('#selected_wallpaper_category').val(categoryName);
      $('#selected_wallpaper_title').val(imageTitle);

      showSelectedImage(imageUrl, categoryName, imageTitle);

      $lightbox.fadeOut(300);
      $('body').removeClass('wallpaper-lightbox-open');
    });

    // Change selection button
    $('#wallpaper-change-btn').on('click', function(e) {
      e.preventDefault();
      $selected.slideUp(300);
      $selector.find('.wallpaper-image-item').removeClass('selected');
      $('#selected_wallpaper_image_id').val('');
      $('#selected_wallpaper_image_url').val('');
      $('#selected_wallpaper_category').val('');
      $('#selected_wallpaper_title').val('');
      $('.wallpaper-selected-title').text('');
      $('.wallpaper-selected-category').text('');

      setTimeout(function() {
        $selector[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 350);
    });

    const hasCustomUpload = () => {
      const $ajaxUploads = $('input[data-is-file="1"][name^="wapf[field_"]');
      const ajaxHasValue = $ajaxUploads.toArray().some((el) => {
        const value = (el.value || '').trim();
        return value.length > 0;
      });

      if (ajaxHasValue) {
        return true;
      }

      const $rawFiles = $('input[type="file"][name^="wapf[field_"]');
      return $rawFiles.toArray().some((el) => el.files && el.files.length > 0);
    };

    const hasValidSelection = () => {
      const imageId = $('#selected_wallpaper_image_id').val();
      if (imageId && imageId !== '') {
        return true;
      }
      return hasCustomUpload();
    };

    // Scroll so the error notice sits below the sticky header and is fully
    // visible. Scrolling to the selector alone left the message off-screen
    // above the viewport (it is prepended to the notices wrapper, which sits
    // above the selector) and/or hidden under the sticky header.
    const scrollToErrorNotice = ($msg) => {
      if (!$msg || !$msg.length) {
        return;
      }
      const $header = $('.banner');
      const headerHeight = ($header.length && $header.css('position') === 'fixed') ? $header.outerHeight() : 0;
      const targetTop = $msg.offset().top - headerHeight - 20;
      $('html, body').animate({ scrollTop: targetTop < 0 ? 0 : targetTop }, 400);
    };

    // Validate selection before add to cart - intercept form submission
    $('form.cart, form.variations_form').on('submit', function(e) {
      if (!$selector.length) {
        return; // Not a wallpaper product, allow submission
      }

      if (!hasValidSelection()) {
        e.preventDefault();
        e.stopPropagation();

        // Remove any existing error messages
        $('.woocommerce-error').remove();

        // Show error message
        const $form = $(this);
        const $wrapper = $('.woocommerce-notices-wrapper').first();

        const messageHtml = '<ul class="woocommerce-error" role="alert"><li>Please select a wallpaper design or upload your own before adding to cart.</li></ul>';

        const $msg = $(messageHtml);
        if ($wrapper.length) {
          $wrapper.prepend($msg);
        } else {
          // Create notices wrapper if it doesn't exist
          const $noticesWrapper = $('<div class="woocommerce-notices-wrapper"></div>');
          $noticesWrapper.append($msg);
          $form.before($noticesWrapper);
        }

        // Scroll to the error notice itself (clearing the sticky header), not
        // just the selector, so the user actually sees why nothing happened.
        scrollToErrorNotice($msg);

        return false;
      }
    });

    // Also validate on add to cart button click (for AJAX add to cart)
    $(document.body).on('adding_to_cart', function(e, $button, data) {
      if (!$selector.length) {
        return; // Not a wallpaper product
      }

      if (!hasValidSelection()) {
        e.preventDefault();
        e.stopPropagation();

        // Remove any existing error messages
        $('.woocommerce-error').remove();

        // Show error message
        const $wrapper = $('.woocommerce-notices-wrapper, form.cart').first();
        const messageHtml = '<ul class="woocommerce-error" role="alert"><li>Please select a wallpaper design or upload your own before adding to cart.</li></ul>';

        if ($wrapper.length) {
          const $msg = $(messageHtml);
          $wrapper.prepend($msg);
          scrollToErrorNotice($msg);
        } else {
          alert('Please select a wallpaper design or upload your own before adding to cart.');
        }

        return false;
      }
    });

    // Lazy loading enhancement
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.full && !img.dataset.loaded) {
              img.dataset.loaded = 'true';
            }
            observer.unobserve(img);
          }
        });
      });

      $selector.find('.wallpaper-image-item img').each(function() {
        imageObserver.observe(this);
      });
    }

    function showSelectedImage(imageUrl, categoryName, imageTitle) {
      $('#wallpaper-selected-img').attr('src', imageUrl);
      $('.wallpaper-selected-title').html(imageTitle ? `<strong>Design Name:</strong> ${imageTitle}` : '');
      $('.wallpaper-selected-category').html(categoryName ? `<strong>Category:</strong> ${categoryName}` : '');
      $selected.slideDown(300);

      setTimeout(function() {
        $selected[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 350);
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
